import { h, Component } from 'preact';

import { getData } from 'utils/dynamicData';
import { joinClasses } from 'utils/utils';
import { renderCookieConsentLink } from 'utils/cookies';
import { copy, a11yCopy, pageName } from 'utils/copy';
import { track } from 'utils/tracking';

import PageLink from 'components/pageLink/pageLink';
import ShareIcons from 'components/shareIcons/shareIcons';

import s from 'components/header/header.sss';

export default class Header extends Component {

	constructor(props) {
		super(props);

		this.state = {
			open: false,
			links: [],
			expandedGroups: new Set(),
		};

		this.processLink = this.processLink.bind(this);
		this.toggleOpen = this.toggleOpen.bind(this);
		this.onAnyClick = this.onAnyClick.bind(this);
		this.renderLink = this.renderLink.bind(this);
		this.trackHeaderLogoClick = this.trackHeaderLogoClick.bind(this);

		if (typeof window !== 'undefined') {
			this.loadData();
		}
	}

	async loadData() {
		try {
			const data = await getData('navigation');
			const links = (data?.header?.links || []).map(this.processLink).filter(e => e);
			this.setState({ links });
		} catch (err) {
			console.error(err);
		}
	}

	processLink(link) {
		if (typeof link === 'string') {
			link = { destination: link };
		}
		if (!link) return;
		if (!link.name) {
			link.name = pageName(link.destination);
		}
		if (link.sublinks) {
			link.sublinks = link.sublinks.map(this.processLink).filter(e => e);
		}
		return link;
	}

	toggleOpen(v) {
		const open = typeof v === 'boolean' ? v : !this.state.open;
		this.setState({ open });
		document.documentElement.classList[open ? 'add' : 'remove']('header-open');
	}

	toggleGroupExpansion(link) {
		const expandedGroups = this.state.expandedGroups;
		if (expandedGroups.has(link)) {
			expandedGroups.delete(link);
		} else {
			expandedGroups.add(link);
		}
		this.setState({ });
	}

	onAnyClick(e) {
		// close on internal navigation
		const link = e.target.closest('a');
		if (!link) return;
		if (!link.target || link.target === '_self') {
			this.toggleOpen(false);
		}

		let href = link.getAttribute('href');
		if (href) {
			let label = link.innerHTML;
			if (link instanceof HTMLElement) {
				label = link.innerText || link.textContent || '';
			}
			if (label) {
				this.trackPersistentButtonClick(label, href);
			}
		}
	}

	trackHeaderLogoClick(e) {
		const link = e.target.closest('a');
		if (!link) return;

		this.trackPersistentButtonClick('landing', link?.href);
	}

	trackPersistentButtonClick(label) {
		track('header', 'header_nav_click', label);
	}

	renderLink(link) {
		if (link.sublinks) {
			// NOTE: should we use the native popover / anchor positioning?
			return (
				<div class={joinClasses(s.navItem, s.expandable, this.state.expandedGroups.has(link) && s.expanded)}>
					<button class={s.name} onClick={() => this.toggleGroupExpansion(link)}>{link.name}</button>
					<nav class={s.popover}>
						{link.sublinks.map(this.renderLink)}
					</nav>
				</div>
			);
		}
		if (link.destination === 'cookies') {
			return renderCookieConsentLink(link.name);
		}
		if (/^https?:\/\//.test(link.destination)) {
			return (
				<a class={s.navItem} href={link.destination} target="_blank" rel="noopener noreferrer">{link.name}</a>
			);
		}
		return (
			<PageLink to={link.destination} class={s.navItem}>{link.name}</PageLink>
		);
	}

	render() {
		return (
			<header class={joinClasses(s.wrapper, this.state.open && s.open)} onClickCapture={this.onAnyClick}>
				<div class={s.main}>
					<button class={s.burger} onClick={this.toggleOpen} />
					<h1>
						<PageLink to="landing" onClick={this.trackHeaderLogoClick}>
							<img src={`${__IMAGE_ROOT__}/logo.svg`} width="79" height="40" alt={a11yCopy('$UNIVERSAL_ALT_TEXT')} fetchpriority="high" />
						</PageLink>
					</h1>
				</div>
				<modal class={s.drawer}>
					<nav class={s.nav}>
						<PageLink to="landing" class={joinClasses(s.navItem, s.mobileOnly)} onClick={this.trackHeaderLogoClick}>{copy('$HEADER_MENU_HOME')}</PageLink>
						{this.state.links.map(this.renderLink)}
					</nav>
					<ShareIcons class={s.share} type="header" />
				</modal>
			</header>
		);
	}

}